import { FC } from 'react'
import cn from 'classnames'

import style from '@src/components/PersonalInfo/Info.module.scss'
import { CheckBoxFormik } from '@src/components/common/CheckBoxFormik/CheckBoxFormik'

type InfoProps = {
    name?: string
    checkBoxName?: string
    className?: string
    onchange?: () => void
    checked?: boolean
    game?: boolean
    url?: string
}

export const InfoGame: FC<InfoProps> = ({
  game, url, checkBoxName, checked, onchange, name, className,
}) => {
  console.log(name)
  return (
    <div className={cn(style.description, style.gameDescription, className)}>
      {game
        ? (
          <>
            <div>
              <CheckBoxFormik
                name={checkBoxName || 'checkBoxRule'}
                type="checkbox"
                onChange={onchange}
                checked={checked}
                label={(
                  <span>
                    Я ознакомлен(а) с
                    {' '}
                    <a
                      href={`${process.env.REACT_APP_SITE_URL}${url}` || `${process.env.REACT_APP_SITE_URL}/files/document/29-politika_cosmostv_v_otnoshenii_obработки_персональных_данных_compressed.pdf`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Правилами проведения Рекламной игры
                    </a>
                    {' '}
                    и выражаю свое согласие на участие в Рекламной игре

                  </span>
                                )}
              />
            </div>

          </>
        ) : (
          <>
            <div>
              <CheckBoxFormik
                name={checkBoxName || 'checkBoxRule'}
                type="checkbox"
                onChange={onchange}
                checked={checked}
                label={(
                  <span>
                    Я согласен(а) на обработку
                    {' '}
                    <a
                      href={`${process.env.REACT_APP_SITE_URL}${url}` || `${process.env.REACT_APP_SITE_URL}/files/document/29-politika_cosmostv_v_otnoshenii_obработки_персональных_данных_compressed.pdf`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      персональных данных
                    </a>
                  </span>
                                )}
              />
            </div>
          </>
        )}
    </div>
  )
}
